import type { KeyboardEventHandler } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useClientOrdersSearchStore } from 'client-app/stores/use-client-orders-search-store';

export const ClientOrdersSearch = () => {
  const { setSearch } = useClientOrdersSearchStore();

  const handleSearch: KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.target instanceof HTMLInputElement) {
      setSearch(e.target.value);
    }
  };

  const handleClear = () => {
    setSearch('');
  };

  return (
    <Input
      prefix={<SearchOutlined />}
      placeholder='Search order'
      allowClear
      onPressEnter={handleSearch}
      onClear={handleClear}
    />
  );
};
